import { render, staticRenderFns } from "./FavouriteItemModal.vue?vue&type=template&id=141adb2b&"
import script from "./FavouriteItemModal.vue?vue&type=script&lang=js&"
export * from "./FavouriteItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports